module.exports = __webpack_public_path__ + "img/m.482021d3.jpg";